import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { Animated } from "react-animated-css";
import { getStringBetween, msToStr,replaceToButton} from "views/ServiceOffering/ExperienceCenter/Sandboxes/AccessSandbox/sdntokenizerhelper"; 

// Material UI Components
import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
// import { Modal } from "@material-ui/core";
import { Modal, Box } from "@mui/material";
import copyIcon from "assets/criterion_networks/svg/copy.svg";
import Icon from "@material-ui/core/Icon";
import * as clipboard from "clipboard-polyfill/text";
import { SECONDARY_COLOR } from "global_constants/app_constants";
import { SHOW_NOTIFICATION } from "action_creators/actioncreator";
import { useDispatch } from "react-redux";
import FeedbackLabs from "../../../../Components/FeedbackLabs";
import Badge from "../../../../Components/badge";
import Tooltip from "@material-ui/core/Tooltip";



const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0 20px",
    backgroundColor: "#ffffff",
  },
  feedbackButton: {
    backgroundColor: "#ff5722", // Highlight color
    color: "#fff",
    animation: "$pulse 1s infinite ease-in-out",
  },
  appBar: {
    backgroundColor: "#ffffff !important",
    color: theme.palette.grey["600"],
    boxShadow: "none",
  },
  tabPanel: {
    backgroundColor: "#ffffff",
    "& div": {
      width: "100%",
      margin: "0",
      paddingTop: "15px"
    },
  },
  customTabRoot: {
    color: `#000`,
    display: "flex",
    flexWrap: "wrap",
    overflow: "hidden",
    "& .MuiTab-root": {
      width: "auto", 
      margin: theme.spacing(1), 
    },
    borderBottom: `1px solid ${theme.palette.grey["400"]}`,
    "& .Mui-selected .MuiTab-wrapper": {
      color: `${theme.palette.secondary.main}`
    },
    "& .MuiTab-wrapper": {
      fontFamily: theme.palette.fontList.selectedFont
    }
  },
  customTab: {
    minWidth: "unset", 
    flex: "1 1 auto", 
  },
  cardStyle: {
    paddingLeft: "25px",
    paddingRight: "25px",
    fontFamily: "Roboto",
    color: "black",
    fontWeight:"normal",
    "& h2": {
      fontWeight: "bold"
    },
    "& img": {
      maxWidth: "100%",
      height: "auto", 
    },
  },
  buttonStyle1: {
    backgroundColor: theme.palette.secondary.main,
    float:"left",
    color: "#fff",
    marginTop: "20px",
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  buttonStyle2: {
    backgroundColor: theme.palette.secondary.main,
    color: "#fff",
    float:"right",
    marginTop: "20px",
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  modalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",  
    transform: "translate(-50%, -50%)",
    background: "white",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    width: "600px",
    maxWidth: "90%",
},
  imageIcon: {
    display: "flex",
    height: "inherit",
    width: "inherit",
    alignSelf: "middle",
    verticalAlign: "super"
  },
  iconRoot: {
    textAlign: "center",
    "& svg": {
      fill: "grey"
    },
    "& svg:hover": {
      fill: "#00AEEF"
    }
  },
  buttStyle: {
    background: theme.palette.buttonColor.main,
    "&:hover": {
      background: theme.palette.buttonColor.main
    }
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}


function Exercises(props) {
  const [value, setValue] = useState(0);
  const [screen,setScreen] = useState("");
  const [categoryIndex, setCategoryIndex] = useState(0);
  const [exerciseIndex, setExerciseIndex] = useState(0);
  const [isPrevButtonNavigation, setIsPrevButtonNavigation] = useState(false);
  const [isNextButtonNavigation, setIsNextButtonNavigation] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [highlight, setHighlight] = useState(true);
  const classes = useStyles();
  const dispatch = useDispatch();
  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };
  const isExerciseEnabled = (exercise) => exercise?.is_enabled !== false;
  const renderers = {
    code: ({ language, value }) => {
      return (
        <pre
          style={{
            cursor: "auto",
            whiteSpace: "break-spaces"
          }}
        >
          <p
            style={{
              width: "100%",
              padding: "15px",
              backgroundColor: SECONDARY_COLOR,
              cursor: "auto"
            }}
          >
            <code
              style={{
                color: "white",
                width: "100%",
                height: "auto",
                padding: "0px",
                backgroundColor: SECONDARY_COLOR
              }}
              language={language}
              children={value}
            />
            <span
              style={{ color: "white", float: "right", cursor: "pointer" }}
              onClick={() => {
                clipboard.writeText(value);
                const payload = {
                  message: "Code copied successfully.",
                  color: "success",
                  delay: 1000
                };
                dispatch(SHOW_NOTIFICATION({ payload }));
              }}
            >
              <Icon classes={{ root: classes.iconRoot }}>
                <img className={classes.imageIcon} alt="logo" src={copyIcon} />
              </Icon>
            </span>
          </p>
        </pre>
      );
    }
  }
  useEffect(() => {
    const categoryIndex = categoriesData.findIndex(
      (category) => category.sandboxes_category_name === currentScreen
    );
    if (categoryIndex !== -1) {
      setCategoryIndex(categoryIndex);
    }
  }, [categoryIndex,exerciseIndex]);
  useEffect(() => {
    if(props.categoryIndex>0 && props.exerciseIndex>0){
      setExerciseIndex(props.exerciseIndex);
      setCategoryIndex(props.categoryIndex);
    }
  }, [props.exerciseIndex],[props.categoryIndex]);  
  useEffect(() => {
    if (categoryIndex === categoriesData.length - 1 && 
        exerciseIndex === exercisesForSelectedCategory.length - 1) {
      setHighlight(true);
    }
  }, [categoryIndex, exerciseIndex]);
  const categoriesData = props.categories[0]
  const exercisesData = props.exercises;
  const host = props.clusterDetails.uuid + "-custom-underlay1"
  var ip = ''
  if(props.clusterDetails.ipdetails !== null){
    ip = props.clusterDetails.ipdetails[host]
  }else{
    ip = ''
  }
  const clusterStatus = props.clusterDetails.status
  let currentScreen = props.data;
  let selectedCategory = categoriesData.find(
    (category) => category.sandboxes_category_name === currentScreen
  );
  if (screen !== currentScreen) {
    setScreen(currentScreen);
    setExerciseIndex(0);
  }
  const exercisesForSelectedCategory = exercisesData[0].filter(
    (exercise) => exercise.admin_sandboxes_categories_id === selectedCategory.id
  );
  if (exercisesForSelectedCategory.length === 0) {
    return <div style={{ textAlign: 'center', marginTop: '50px' }}><b>No exercises available for this category.</b></div>;
  }
  const sortedExercisesData = exercisesForSelectedCategory.slice().sort((a, b) => a.exercise_position - b.exercise_position);
  const findNextEnabledIndex = (data, fromIndex) => {
    for (let i = fromIndex + 1; i < data.length; i++) {
      if (isExerciseEnabled(data[i])) return i;
    }
    return -1;
  };
  const findPrevEnabledIndex = (data, fromIndex) => {
    for (let i = fromIndex - 1; i >= 0; i--) {
      if (isExerciseEnabled(data[i])) return i;
    }
    return -1;
  };
  let currentExercise = sortedExercisesData[exerciseIndex];
  if(currentExercise === undefined){
    currentExercise = sortedExercisesData[0];
    setExerciseIndex(0)
  }
  if (!isExerciseEnabled(currentExercise)) {
    const firstEnabledIndex = sortedExercisesData.findIndex(isExerciseEnabled);
    if (firstEnabledIndex !== -1) {
      currentExercise = sortedExercisesData[firstEnabledIndex];
      if (exerciseIndex !== firstEnabledIndex) {
        setExerciseIndex(firstEnabledIndex);
      }
    }
  }

  const handleTabChange = (event, newValue) => {

    setIsPrevButtonNavigation(false);
    setIsNextButtonNavigation(false);
    setExerciseIndex(newValue);
  }; 
  const handlePrev = () => {
    setIsPrevButtonNavigation(true);
    const prevEnabledIndex = findPrevEnabledIndex(sortedExercisesData, exerciseIndex);
    if (prevEnabledIndex !== -1) {
      setExerciseIndex(prevEnabledIndex);
      return;
    }
    if (categoryIndex === 0) {
      props.changeActiveTab("Overview");
    } else {
      const prevCategoryIndex = categoryIndex - 1;
      const prevCategoryExercises = exercisesData[0].filter(
        (exercise) => exercise.admin_sandboxes_categories_id === categoriesData[prevCategoryIndex].id
      );
      setExerciseIndex(prevCategoryExercises.length - 1);
      setCategoryIndex(prevCategoryIndex);
      setExerciseIndex(prevCategoryExercises.length - 1);
      selectedCategory = categoriesData[categoryIndex-1]
      setScreen(selectedCategory.sandboxes_category_name)
      props.changeActiveTab(selectedCategory.sandboxes_category_name)
      }
  };
  const toggleFeedbackForm = () => {
    setModalOpen((prev) => !prev);
  };

  const handleNext = () => {
    setIsNextButtonNavigation(true);
    const nextEnabledIndex = findNextEnabledIndex(sortedExercisesData, exerciseIndex);
    if (nextEnabledIndex !== -1) {
      setExerciseIndex(nextEnabledIndex);
      return;
    }
    if (categoryIndex ===categoriesData.length - 1 ) {
      if(props.badgeInfo){
        props.changeActiveTab("Skill Badge")
      } else if(props.sandboxCheatsheets && props.sandboxCheatsheets.length > 0){
        props.changeActiveTab("Cheat sheets");
      } else {
        props.changeActiveTab("Access devices")
      }
    } else {
      setExerciseIndex(0);
      setCategoryIndex((prevIndex) => prevIndex + 1);
      selectedCategory = categoriesData[categoryIndex+1]
      props.changeActiveTab(selectedCategory.sandboxes_category_name)
    }
  };

  const renderPanels = (inputString, ip, host,clusterStatus, renderers) => {
    if (inputString) {
      const panels = getStringBetween(inputString, "%%beginpanel%%", "%%endpanel%%");
      if (panels.length !== 0) {
        return panels.map((panel, index) => {
          panel = replaceToButton(
            panel,
            ip,
            host,
            clusterStatus,
            "%%beginbtn%%",
            "%%endbtn%%"
          );
          var launch = true;
          if (panel.includes('class="button" value="Launch"')) {
            launch = false;
          }
          return (
            <Animated
              key={index} // Ensure each element has a unique key when rendering a list of elements
              animationIn="fadeIn"
              animationOut="fadeOut"
              animationInDuration={2000}
              isVisible={true}
            >
              <ReactMarkdown
                className="panel"
                source={panel}
                escapeHtml={false}
                renderers={renderers}
              />
              {panel?.replace("\r", "")?.replace("\n", "")?.length ? <hr /> : null}
            </Animated>
          );
        });
      }
    }
    return null; 
  };

  const renderExerciseContent = (intro_list, solution) => {
    const combinedContent = `${intro_list || ''}${solution || ''}`;


    const introListPanels = renderPanels(intro_list, ip, host, clusterStatus, renderers);
    const solutionPanels = renderPanels(solution, ip, host, clusterStatus, renderers);


    return (
      <>
        {introListPanels}
        {intro_list && !introListPanels && ( 
          <div className={classes.cardStyle}>
            <ReactMarkdown source={intro_list} skipHtml={false} renderers={renderers} />
          </div>
        )}
        {solutionPanels}
        {solution && !solutionPanels && ( 
          <div className={classes.cardStyle}>
            <ReactMarkdown source={solution} skipHtml={false} renderers={renderers} />
          </div>
        )}
      </>
    );
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Tabs
          value={exerciseIndex}
          onChange={handleTabChange}
          aria-label="simple tabs example"
          classes={{
            root: classes.customTabRoot
          }}
        >
          {sortedExercisesData.map((exercise, index) => {
              const enabled = isExerciseEnabled(exercise);
              const tab = (
                <Tab
                  key={index}
                  label={exercise.title}
                  disabled={!enabled}
                  {...a11yProps(index)}
                  className={sortedExercisesData.length > 6 ? classes.customTab : ''}
                />
              );
              return enabled ? (
                tab
              ) : (
                <Tooltip key={index} title="This exercise is currently disabled" arrow>
                  <span>{tab}</span>
                </Tooltip>
              );
            })}
        </Tabs>
      </AppBar>
      <div className={classes.tabContainer}>
          <TabPanel
            className={classes.tabPanel}
          >
             <Grid
            container
            justify="center"
            alignItems="center"
            style={{ flexDirection: "row", flexWrap: "wrap" }}
          >
           {renderExerciseContent(currentExercise.intro_list,currentExercise.solution)}
          </Grid>
          </TabPanel>
      </div>
          <Button
            onClick={handlePrev}
            className={classes.buttonStyle1}
          >
            Prev
          </Button>
          <div>
            
            {!props.isFeedbackGiven && // Hide button if feedback is already given
              categoryIndex === categoriesData.length - 1 &&
              exerciseIndex === exercisesForSelectedCategory.length - 1 && JSON.parse(localStorage.getItem("profileData"))?.privilege === "developer" &&(
                <>
                  <Tooltip title="Your feedback helps us improve!" arrow>
                    <Button
                      className={classes.buttonStyle2}
                      onClick={() => {
                        setModalOpen(true);
                        setHighlight(false); // Stop animation after clicking
                      }}
                      onMouseEnter={() => setHighlight(false)} // Stop animation on hover
                      style={{
                        animation: highlight ? "pulse 1.5s infinite" : "none",
                        marginLeft: "4px",
                      }}
                    >
                      Feedback
                    </Button>
                  </Tooltip>

                  {/* Feedback Modal */}
                  <Modal open={isModalOpen}onClose={toggleFeedbackForm} aria-labelledby="modal-title">
                    <Box className={classes.modalContainer}>
                      <h2 id="modal-title">Feedback Form</h2>
                      <FeedbackLabs category="Sandboxes" subcategory={props.templateName} uuid={props.clusterDetails.uuid} onClose={toggleFeedbackForm} submitFeedback={(email) => {setTimeout(() => {props.CreateBadge(email); toggleFeedbackForm();}, 1000)}}/>                 
                    </Box>
                  </Modal>
                </>
              )}
          </div>
          <Button
            onClick={handleNext}
            className={classes.buttonStyle2}
          >
            Next
          </Button>
    </div>
  );
}

export default Exercises;